var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelProjectDotsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_90847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 -6.10352e-05C3.576 -6.10352e-05 0 3.57594 0 7.99994C0 12.4239 3.576 15.9999 8 15.9999C12.424 15.9999 16 12.4239 16 7.99994C16 3.57594 12.424 -6.10352e-05 8 -6.10352e-05ZM11.44 11.4399C11.366 11.5141 11.2781 11.5729 11.1813 11.6131C11.0845 11.6532 10.9808 11.6739 10.876 11.6739C10.7712 11.6739 10.6675 11.6532 10.5707 11.6131C10.4739 11.5729 10.386 11.5141 10.312 11.4399L8 9.12794L5.688 11.4399C5.53842 11.5895 5.33554 11.6736 5.124 11.6736C4.91246 11.6736 4.70958 11.5895 4.56 11.4399C4.41042 11.2904 4.32638 11.0875 4.32638 10.8759C4.32638 10.7712 4.34701 10.6675 4.3871 10.5707C4.42718 10.4739 4.48593 10.386 4.56 10.3119L6.872 7.99994L4.56 5.68794C4.41042 5.53836 4.32638 5.33548 4.32638 5.12394C4.32638 4.9124 4.41042 4.70952 4.56 4.55994C4.70958 4.41036 4.91246 4.32632 5.124 4.32632C5.33554 4.32632 5.53842 4.41036 5.688 4.55994L8 6.87194L10.312 4.55994C10.3861 4.48587 10.474 4.42712 10.5708 4.38704C10.6675 4.34695 10.7713 4.32632 10.876 4.32632C10.9807 4.32632 11.0845 4.34695 11.1812 4.38704C11.278 4.42712 11.3659 4.48587 11.44 4.55994C11.5141 4.634 11.5728 4.72193 11.6129 4.8187C11.653 4.91548 11.6736 5.01919 11.6736 5.12394C11.6736 5.22868 11.653 5.3324 11.6129 5.42917C11.5728 5.52594 11.5141 5.61387 11.44 5.68794L9.128 7.99994L11.44 10.3119C11.744 10.6159 11.744 11.1279 11.44 11.4399Z",
    fill: "#FC8181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_90847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelProjectDotsMenu);
export default __webpack_public_path__ + "static/media/CancelProjectDotsMenu.28d1f38416d1b1c485b6551992d9d5aa.svg";
export { ForwardRef as ReactComponent };